const className = 'keyboard-navigation';
let assigned = false;

/**
 * Due to Safari lacking support for :focus-visible we need to add a temp script
 * that adds similar behavior. This script adds a class on the body and using
 * css variables we use :focus to do the same styles we would with
 * :focus-visible. Once Safari has adequate :focus-visible support this js code
 * will be removed and styles will switch from :focus to :focus-visible.
 *
 * @public
 */
function bindKeyboardListeners() {
  const classList = document.body.classList;

  window.addEventListener('keydown', function keydown(ev) {
    if (ev.key !== 'Tab' || classList.contains(className)) return;
    classList.add(className);

    window.addEventListener('click', function remove() {
      classList.remove(className);
    }, { once: true, passive: true });
  }, { passive: true });
}

function registerKeyboardNavListener() {
  const ssr = typeof window === 'undefined' || typeof window.addEventListener !== 'function';

  if (assigned || ssr) return;
  assigned = true;

  if (!document.body) return;

  if (!document.body.classList) {
    document.addEventListener('DOMContentLoaded', bindKeyboardListeners);
  } else {
    bindKeyboardListeners();
  }
}

export { registerKeyboardNavListener };
